import { useDispatch } from 'react-redux';
import { FaSave } from 'react-icons/fa';
import { cancelCaseSubmission, saveCaseProgress } from '../../redux/actions/liabilty';
import {ReactComponent as SaveIcon} from '../../assets/icons/FloppyDisk.svg'

const SaveCaseProgressButton = ({ innerRefs, isFromCase }) => {

    const dispatch = useDispatch();

    const saveCaseProgressData = () => {
        const submitButton = innerRefs.current.querySelector('#submit');
        if (submitButton) {
            dispatch(cancelCaseSubmission(true))
            dispatch(saveCaseProgress(true))
            submitButton.click()
        }
    }

    return (
        <button
            onClick={saveCaseProgressData}
            type="button"
            className={`save-btn ${isFromCase ? '' : 'mt-4' }`}
            id="saveProgress"
            style={{marginLeft:'30px'}}
        >
            <SaveIcon/><span style={{marginLeft:'5px'}}>Save</span>
        </button>
    );
};

export default SaveCaseProgressButton;